module.exports = __webpack_public_path__ + "img/facebook-marketing-partner.75a0ef6b.svg";